// TODO: jjw: put field keys in enums & map to display values

export interface ServicingPayment {
  id: number;
  loan_application_id: number;
  payment_period: string; // CivilDate ("YYYY-MM-01")
  check_date: string; // CivilDate ("YYYY-MM-DD")
  check_amount: number;
  check_document_id: number | null;
  coupon_additional_principal: number;
  coupon_additional_escrow: number;
  coupon_late_charge: number;
  coupon_fees: number;
  coupon_mortgage_recoverable_advances: number;
  coupon_total_amount_enclosed: number;
  notes: string;
  created_at: string;
  updated_at: string;
}

/** For taking a ServicingPayment emitted by the API and parsing number values from strings. */
export const parseServicingPaymentResponse = (obj: any): ServicingPayment => ({
  ...obj,
  id: Number(obj.id),
  loan_application_id: Number(obj.loan_application_id),
  check_amount: Number(obj.check_amount),
  check_document_id: obj.check_document_id === null ? null : Number(obj.check_document_id),
  coupon_additional_principal: Number(obj.coupon_additional_principal),
  coupon_additional_escrow: Number(obj.coupon_additional_escrow),
  coupon_late_charge: Number(obj.coupon_late_charge),
  coupon_fees: Number(obj.coupon_fees),
  coupon_mortgage_recoverable_advances: Number(obj.coupon_mortgage_recoverable_advances),
  coupon_total_amount_enclosed: Number(obj.coupon_total_amount_enclosed),
});

export interface ActualEscrow {
  id: number;
  loan_application_id: number;
  payment_period: string;
  actual_tax_payment: number;
  actual_insurance_payment: number;
  actual_mortgage_insurance_payment: number;
  actual_disbursement_amount: number;
  created_at: string;
  updated_at: string;
}

/** For taking a ActualEscrow emitted by the API and parsing number values from strings. */
export const parseActualEscrowResponse = (obj: any): ActualEscrow => ({
  ...obj,
  id: Number(obj.id),
  loan_application_id: Number(obj.loan_application_id),
  payment_period: obj.payment_period,
  actual_tax_payment: Number(obj.actual_tax_payment),
  actual_insurance_payment: Number(obj.actual_insurance_payment),
  actual_mortgage_insurance_payment: Number(obj.actual_mortgage_insurance_payment),
  actual_disbursement_amount: Number(obj.actual_disbursement_amount),
});
